import type { UploadFile } from "antd/es/upload/interface";
import { v4 as uuidv4 } from "uuid";

export type MessageSubmissionFile = UploadFile<File> & {
  file_url?: string;
  content_type?: string;
  file_size?: number;
  storage_provider?: string;
};

export type MessageSubmissionCache = {
  signature: string;
  clientRequestId: string;
  uploadedAttachments: any[] | null;
};

const getFileFingerprint = (file: MessageSubmissionFile) => {
  const originFile = file.originFileObj;

  return {
    uid: file.uid || "",
    name: file.name || originFile?.name || "",
    size: file.size ?? originFile?.size ?? null,
    type: file.type || originFile?.type || "",
    lastModified: originFile?.lastModified ?? null,
    fileUrl: file.file_url || "",
  };
};

/**
 * Identifies the user-visible message draft, not the server-upload result.
 * Keeping this stable lets a failed POST reuse the exact uploaded attachment
 * payload while any content or attachment change starts a new idempotency key.
 */
export const getMessageDraftSignature = (
  content: string,
  files: MessageSubmissionFile[] = [],
) =>
  JSON.stringify({
    content,
    files: files.map(getFileFingerprint),
  });

export const getOrCreateMessageSubmission = (
  current: MessageSubmissionCache | null | undefined,
  content: string,
  files: MessageSubmissionFile[] = [],
): MessageSubmissionCache => {
  const signature = getMessageDraftSignature(content, files);

  if (current?.signature === signature) {
    return current;
  }

  return {
    signature,
    clientRequestId: uuidv4(),
    uploadedAttachments: null,
  };
};
